import cn from 'bem-cn';

import { PHANTOMAS_ACHIEVEMENT_IMAGE } from '../../../constants';
import { Skeleton, Stack } from '../../UI';

import euroslot from '../../../images/achievement/euroslot.svg';
import './AchievementCard.scss';

const b = cn('achievement-card');

export const AchievementCardSkeleton = () => {
    return (
        <div className={b()}>
            <img className={b('euroslot')} src={euroslot} alt="" />
            <Stack className={b('content')}>
                <img className={b('image')} src={PHANTOMAS_ACHIEVEMENT_IMAGE} alt="" />
                <Stack className={b('text-content')}>
                    <h3>
                        <Skeleton width="80%" style={{ margin: '0 auto' }} />
                    </h3>
                    <Stack spacing={4}>
                        <p>
                            <Skeleton width="70%" style={{ margin: '0 auto' }} />
                        </p>
                        <p>
                            <Skeleton width="50%" style={{ margin: '0 auto' }} />
                        </p>
                    </Stack>
                </Stack>
            </Stack>
        </div>
    );
};
